<template>
    <PageSidebar>
        <template #sidebarTitle>
            <div class="space-x-3">
                <ButtonSecondaryIconSm @click="quit">
                    <ArrowLeftIcon />
                </ButtonSecondaryIconSm>
                <span> {{ $t("cookie.groups.edit") }}</span>
            </div>
        </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <component :is="item.icon" class="w-6 h-6 text-primary" />
                <FormInput id="consentTypeName" :title="$t('shared.name')" v-model="name" />

                <FormTextArea :title="$t('shared.url')" v-model="info" :rows="10" />
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="$emit('save')" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import { ButtonSecondaryIconSm } from "@easy/ui/buttons";
import { ArrowLeftIcon } from "@easy/ui/icons";
import { FormInput, FormTextArea } from "@easy/ui/forms";
import { useSaveOrDropModal } from "@/store/useSaveOrDropModal";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";

export default {
    components: {
        PageSidebar,
        ButtonSecondaryIconSm,
        ArrowLeftIcon,
        FormInput,
        FormTextArea,
        cSaveButton,
    },
    props: {
        item: String,
    },
    setup() {
        useFocusOnQueryField();
        const { askToConfirmIfNeeded } = useSaveOrDropModal();
        return {
            askToConfirmIfNeeded,
        };
    },
    data() {
        return {
            nameCopy: "",
            infoCopy: "",
        };
    },
    emits: ["save", "cancel"],
    computed: {
        ...mapState("cookie", ["cookie", "hasChanges", "consentTypes"]),
        ...mapGetters("cookie", ["defaultTypes"]),
        name: {
            get() {
                return this.getTypes("name", this.item);
            },
            set(value) {
                this.setTypes("name", this.item, value);
            },
        },
        info: {
            get() {
                return this.getTypes("info", this.item);
            },
            set(value) {
                this.setTypes("info", this.item, value);
            },
        },
    },

    mounted() {
        this.nameCopy = this.getTypes("name", this.item);
        this.infoCopy = this.getTypes("info", this.item);
    },
    methods: {
        getTypes(prop, type) {
            return (
                (this.cookie.consentTypes[type] && this.cookie.consentTypes[type][prop]) ||
                this.defaultTypes[type][prop]
            );
        },
        setTypes(prop, type, value) {
            const defaultValue = this.defaultTypes[type][prop];

            if (!this.cookie.consentTypes[type]) this.cookie.consentTypes[type] = {};

            if (value !== defaultValue) {
                this.cookie.consentTypes[type][prop] = value;
            } else {
                this.cookie.consentTypes[type][prop] = "";
            }
        },
        cancelChanges() {
            this.name = this.nameCopy;
            this.info = this.infoCopy;
            this.$emit("cancel");
        },
        async quit() {
            const result = await this.askToConfirmIfNeeded({
                showModal: this.hasChanges,
                onConfirmChanges: () => this.$emit("save"),
            });
            if (!result) {
                this.cancelChanges();
            }
        },
    },
};
</script>
